module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q7-lockup.b0e5953c.png";